import {SET_FEE_TYPES_LIST} from '../mutation-types';
import {getFeeTypes} from '@/api/fee-type-api';

const initialState = {
    list: []
};

const getters = {
    activeFeeTypes: state => {
        return state.list.filter(feeType => feeType.active);
    }
};

const mutations = {
    [SET_FEE_TYPES_LIST](state, feeTypes) {
        state.list = feeTypes;
    }
};

const actions = {
    loadFeeTypes({commit}) {
        return new Promise((resolve, reject) => {
            getFeeTypes()
                .then(feeTypes => {
                    commit(SET_FEE_TYPES_LIST, feeTypes);
                    resolve(true);
                })
                .catch(() => {
                    reject(false);
                });
        });
    }
};

export default {
    state: initialState,
    getters,
    mutations,
    actions
}